$('.swiper-wrapper').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    nextArrow: '.swiper-button-next',
    prevArrow: '.swiper-button-prev',
    appendDots: '.swiper-pagination',
    lazyLoad: 'ondemand',
    adaptiveHeight: true
});
